import { AppendRequestBody, AssignReturnRequestBody, ChangeDocumentStatusRequestBody, PartialUploadRequestBody, RecognizeReturnRequestBody, ResendAccessLinkRequestBody, ReturnsBaseRequestBody, ReturnsFalseBaseRequestBody, SecondBaseRequestBody, SendReminderRequestBody, SetAccessRequestBody, SetDownloadStatusRequestBody, UploadRequestBody } from "../../common/model/ssr/requestBody";
import { DeliveredReturnParameter, InProcessReturnsRequestParameter, RecycleBinReturnRequestParameter, RequiredTaxReturnIdParameter, SSR_ArchivedReturn_ArchivedReturnsRequestParameter, SSR_ArchivedReturn_SignatureStatusRequestParameter } from "../../common/model/ssr/requestParameter";
import { AccessLinkResponseBody, AppendResponseBody, Data, DeliveredReturnResponseBody, EFileFormResponseBody, FetchReturnResponseBody, InProcessReturnsResponseBody, RecycleBinReturnResponseBody, SignatureStatusResponseBody, SignersInfoResponseBody, SSR_ArchivedReturn_ArchivedReturnsResponseBody, SSR_ArchivedReturn_SignatureStatusResponseBody, UnRecognizedReturnResponseBody, UploadedResponseBody } from "../../common/model/ssr/responseBody";
import { baseRequestParameter, SSR_ArchivedReturn_ArchivedReturnsParameter, SSR_ArchivedReturnAPI_GetAccessLinkParameter, SSR_ArchivedReturnAPI_SignatureStatusParameter, SSR_ArchivedReturnAPI_SignerInfoParameter, SSR_BaseFalseRequestBodyParameter, SSR_DeliveredAPI_DeliveredReturnsParameter, SSR_DeliveredAPI_GetAccessLinkParameter, SSR_DeliveredAPI_GetEFileFormsParameter, SSR_DeliveredAPI_ResendAccessLinkParameter, SSR_DeliveredAPI_SignatureStatusParameter, SSR_DeliveredAPI_SignerInfoParameter, SSR_InProcessAPI_assignReturnParameter, SSR_InProcessAPI_ChangeDocumentStatusParameter, SSR_InProcessAPI_GetAllParameter, SSR_RecycleBin_GetAllParameter, SSR_Returns_RecognizeReturnParameter, SSR_ReturnsAPI_AppendParameter, SSR_ReturnsAPI_FetchReturnParameter, SSR_ReturnsAPI_PartialUploadParameter, SSR_ReturnsAPI_SetAccessParameter, SSR_ReturnsAPI_UnRecognizedReturnParameter, SSR_ReturnsAPI_UploadedParameter, SSR_ReturnsAPI_UploadParameter, SSR_ReturnStatus_SetDownloadStatusParameter, SSR_SecondBaseRequestParameter } from "../apiParameters";
import { baseResponseBody } from "../objectTypeConstants";

export const baseRequestBody: ReturnsBaseRequestBody = {
  requiredDocuments: baseRequestParameter.requiredDocuments,
  requiredFileURLs: baseRequestParameter.requiredFileURLs,
  correlationId: baseRequestParameter.correlationId,
}

export const secondBaseRequestBody: SecondBaseRequestBody = {
  requiredTaxReturnId: SSR_SecondBaseRequestParameter.taxReturnId,
  requiredCorrelationID: SSR_SecondBaseRequestParameter.correlationId,
  callbackUri: SSR_SecondBaseRequestParameter.callbackUri,
}

export const baseFalseRequestBody: ReturnsFalseBaseRequestBody = {
  documents: SSR_BaseFalseRequestBodyParameter.documents,
  fileURLs: SSR_BaseFalseRequestBodyParameter.fileURLs,
  correlationId: SSR_BaseFalseRequestBodyParameter.correlationId,
}

export const requiredTaxReturnIdParameter: RequiredTaxReturnIdParameter = {
  requiredTaxReturnId: SSR_DeliveredAPI_GetAccessLinkParameter.taxReturnIdQuery
}

export const uploadRequestBody: UploadRequestBody = {
  documents: SSR_ReturnsAPI_UploadParameter.documents,
  fileURLs: SSR_ReturnsAPI_UploadParameter.fileURLs,
  correlationId: SSR_ReturnsAPI_UploadParameter.correlationId,
  rid: SSR_ReturnsAPI_UploadParameter.rid,
  requiredClientId: SSR_ReturnsAPI_UploadParameter.clientId,
  delayRecognition: SSR_ReturnsAPI_UploadParameter.delayRecognition,
  requiredCallbackUri: SSR_ReturnsAPI_UploadParameter.callbackUri,
  requiredTaxSoftware: SSR_ReturnsAPI_UploadParameter.taxSoftware,
}

export const appendReturnRequestBody: AppendRequestBody = {
  ...baseRequestBody,
  ...requiredTaxReturnIdParameter,
}

export const partialUploadRequestBody: PartialUploadRequestBody = {
  ...baseFalseRequestBody,
  rid: SSR_ReturnsAPI_PartialUploadParameter.rid,
  clientId: SSR_ReturnsAPI_PartialUploadParameter.clientId,
  taxSoftware: SSR_ReturnsAPI_PartialUploadParameter.taxSoftware
}

export const recognizeReturnRequestBody: RecognizeReturnRequestBody = {
  requiredTaxReturnId: secondBaseRequestBody.requiredTaxReturnId,
  correlationId: SSR_Returns_RecognizeReturnParameter.correlationId,
  callbackUri: secondBaseRequestBody.callbackUri
}

export const setAccessRequestBody: SetAccessRequestBody = {
  requiredTaxReturnId: secondBaseRequestBody.requiredTaxReturnId,
  assignedTo: SSR_ReturnsAPI_SetAccessParameter.assignedTo,
}

export const uploadedResponseBody: UploadedResponseBody & Data = {
  ...baseResponseBody,
  data: {
    rid: SSR_ReturnsAPI_UploadedParameter.rid,
    clientId: SSR_ReturnsAPI_UploadedParameter.clientId,
    isRecognized: SSR_ReturnsAPI_UploadedParameter.isRecognized,
    CreatedDate: SSR_ReturnsAPI_UploadedParameter.CreatedDate,
    RecognitionDate: SSR_ReturnsAPI_UploadedParameter.RecognitionDate,
    taxSoftware: SSR_ReturnsAPI_UploadedParameter.taxSoftware,
    delayRecognition: SSR_ReturnsAPI_UploadedParameter.delayRecognition,
    taxReturnId: SSR_ReturnsAPI_UploadedParameter.taxReturnId,
  },
}

export const baseResponseWithTaxReturnIdResponseBody: AppendResponseBody & Data = {
  ...baseResponseBody,
  data: {
    taxReturnId: SSR_ReturnsAPI_AppendParameter.taxReturnId,
  },
}

export const fetchReturnResponseBody: FetchReturnResponseBody & Data = {
  ...baseResponseBody,
  data: {
    taxReturnId: SSR_ReturnsAPI_FetchReturnParameter.taxReturnId,
    taxYear: SSR_ReturnsAPI_FetchReturnParameter.taxYear,
    clientId: SSR_ReturnsAPI_FetchReturnParameter.clientId,
    clientName: SSR_ReturnsAPI_FetchReturnParameter.clientName,
    signatureStatus: SSR_ReturnsAPI_FetchReturnParameter.signatureStatus,
    engagementType: SSR_ReturnsAPI_FetchReturnParameter.engagementType,
    isArchived: SSR_ReturnsAPI_FetchReturnParameter.isArchived,
    draftStatus: SSR_ReturnsAPI_FetchReturnParameter.draftStatus,
    groupName: SSR_ReturnsAPI_FetchReturnParameter.groupName,
  }
}

export const unRecognizedReturnResponseBody: UnRecognizedReturnResponseBody & Data = {
  ...baseResponseBody,
  data: {
    rid: SSR_ReturnsAPI_UnRecognizedReturnParameter.rid,
    clientId: SSR_ReturnsAPI_UnRecognizedReturnParameter.clientId,
    uploadedDate: SSR_ReturnsAPI_UnRecognizedReturnParameter.uploadedDate,
    taxSoftware: SSR_ReturnsAPI_UnRecognizedReturnParameter.taxSoftware,
    taxReturnId: SSR_ReturnsAPI_UnRecognizedReturnParameter.taxReturnId
  }
}

export const changeDocumentStatusRequestBody: ChangeDocumentStatusRequestBody = {
  ...secondBaseRequestBody,
  requiredDocumentStatus: SSR_InProcessAPI_ChangeDocumentStatusParameter.documentStatus,
}

export const assignReturnRequestBody: AssignReturnRequestBody = {
  taxReturnIds: SSR_InProcessAPI_assignReturnParameter.taxReturnIds,
  userId: SSR_InProcessAPI_assignReturnParameter.userId,
}

export const inProcessReturnsRequestParameter: InProcessReturnsRequestParameter = {
  clientIdQuery: SSR_InProcessAPI_GetAllParameter.clientIdQuery,
  clientNameQuery: SSR_InProcessAPI_GetAllParameter.clientNameQuery,
  taxYearQuery: SSR_InProcessAPI_GetAllParameter.taxYearQuery,
  eroQuery: SSR_InProcessAPI_GetAllParameter.eroQuery,
  assignedToQuery: SSR_InProcessAPI_GetAllParameter.assignedToQuery,
  documentStatusQuery: SSR_InProcessAPI_GetAllParameter.documentStatusQuery,
  engagementTypeQuery: SSR_InProcessAPI_GetAllParameter.engagementTypeQuery,
  uploadedAfterQuery: SSR_InProcessAPI_GetAllParameter.uploadedAfterQuery,
  draftStatusQuery: SSR_InProcessAPI_GetAllParameter.draftStatusQuery,
  pageSizeQuery: SSR_InProcessAPI_GetAllParameter.pageSizeQuery,
  pageNumberQuery: SSR_InProcessAPI_GetAllParameter.pageNumberQuery,
  sortByQuery: SSR_InProcessAPI_GetAllParameter.sortByQuery,
  sortOrderQuery: SSR_InProcessAPI_GetAllParameter.sortOrderQuery,
}

export const inProcessReturnsResponseBody: InProcessReturnsResponseBody = {
  ...baseResponseBody,
  data: {
    taxReturnId: SSR_InProcessAPI_GetAllParameter.taxReturnId,
    documentStatus: SSR_InProcessAPI_GetAllParameter.documentStatus,
    draftStatus: SSR_InProcessAPI_GetAllParameter.draftStatus,
    assignedToFirstName: SSR_InProcessAPI_GetAllParameter.assignedToFirstName,
    assignedToLastName: SSR_InProcessAPI_GetAllParameter.assignedToLastName,
    eroSignerFirstName: SSR_InProcessAPI_GetAllParameter.eroSignerFirstName,
    eroSignerLastName: SSR_InProcessAPI_GetAllParameter.eroSignerLastName,
    taxYear: SSR_InProcessAPI_GetAllParameter.taxYear,
    uploadedOn: SSR_InProcessAPI_GetAllParameter.uploadedOn,
    engagementType: SSR_InProcessAPI_GetAllParameter.engagementType,
    taxSoftware: SSR_InProcessAPI_GetAllParameter.taxSoftware,
    clientId: SSR_InProcessAPI_GetAllParameter.clientId,
    clientName: SSR_InProcessAPI_GetAllParameter.clientName,
    locationId: SSR_InProcessAPI_GetAllParameter.locationId,
    groupName: SSR_InProcessAPI_GetAllParameter.groupName,
  }
}

export const recycleBinReturnRequestParameter: RecycleBinReturnRequestParameter = {
  clientNameQuery: SSR_RecycleBin_GetAllParameter.clientNameQuery,
  clientIdQuery: SSR_RecycleBin_GetAllParameter.clientIdQuery,
  taxYearQuery: SSR_RecycleBin_GetAllParameter.taxYearQuery,
  engagementTypeQuery: SSR_RecycleBin_GetAllParameter.engagementTypeQuery,
  eroQuery: SSR_RecycleBin_GetAllParameter.eroQuery,
  sentByQuery: SSR_RecycleBin_GetAllParameter.sentByQuery,
  deliveredAfterQuery: SSR_RecycleBin_GetAllParameter.deliveredAfterQuery,
  statusQuery: SSR_RecycleBin_GetAllParameter.statusQuery,
  deletedOnQuery: SSR_RecycleBin_GetAllParameter.deletedOnQuery,
  deletedByQuery: SSR_RecycleBin_GetAllParameter.deletedByQuery,
  pageSizeQuery: SSR_RecycleBin_GetAllParameter.pageSizeQuery,
  pageNumberQuery: SSR_RecycleBin_GetAllParameter.pageNumberQuery,
  sortByQuery: SSR_RecycleBin_GetAllParameter.sortByQuery,
  sortOrderQuery: SSR_RecycleBin_GetAllParameter.sortOrderQuery,
}

export const recycleBinReturnResponseBody: RecycleBinReturnResponseBody = {
  ...baseResponseBody,
  data: {
    Id: SSR_RecycleBin_GetAllParameter.id,
    taxReturnId: SSR_RecycleBin_GetAllParameter.taxReturnId,
    clientName: SSR_RecycleBin_GetAllParameter.clientName,
    clientId: SSR_RecycleBin_GetAllParameter.clientId,
    eroSignerFirstName: SSR_RecycleBin_GetAllParameter.eroSignerFirstName,
    eroSignerLastName: SSR_RecycleBin_GetAllParameter.eroSignerLastName,
    engagementType: SSR_RecycleBin_GetAllParameter.engagementType,
    taxYear: SSR_RecycleBin_GetAllParameter.taxYear,
    deliveredOn: SSR_RecycleBin_GetAllParameter.deliveredOn,
    deliveredByFirstName: SSR_RecycleBin_GetAllParameter.deliveredByFirstName,
    deliveredByLastName: SSR_RecycleBin_GetAllParameter.deliveredByLastName,
    deletedOn: SSR_RecycleBin_GetAllParameter.deletedOn,
    deletedByFirstName: SSR_RecycleBin_GetAllParameter.deletedByFirstName,
    deletedByLastName: SSR_RecycleBin_GetAllParameter.deletedByLastName,
    signatureStatus: SSR_RecycleBin_GetAllParameter.signatureStatus,
    locationId: SSR_RecycleBin_GetAllParameter.locationId,
    groupName: SSR_RecycleBin_GetAllParameter.groupName,
  }
}

export const resendAccessLinkRequestBody: ResendAccessLinkRequestBody = {
  requiredTaxReturnId: SSR_SecondBaseRequestParameter.taxReturnId,
  requiredCorrelationID: SSR_SecondBaseRequestParameter.correlationId,
  requiredSignerGuid: SSR_DeliveredAPI_ResendAccessLinkParameter.signerGuid,
}

export const sendReminderRequestBody: SendReminderRequestBody = {
  requiredTaxReturnId: SSR_SecondBaseRequestParameter.taxReturnId,
  requiredCorrelationID: SSR_SecondBaseRequestParameter.correlationId,
}

export const accessLinkResponseBody: AccessLinkResponseBody & Data = {
  ...baseResponseBody,
  data: {
    clientId: SSR_DeliveredAPI_GetAccessLinkParameter.clientId,
    clientName: SSR_DeliveredAPI_GetAccessLinkParameter.clientName,
    taxYear: SSR_DeliveredAPI_GetAccessLinkParameter.taxYear,
    signatureStatus: SSR_DeliveredAPI_GetAccessLinkParameter.signatureStatus,
    accessLinkTaxpayer: SSR_DeliveredAPI_GetAccessLinkParameter.accessLinkTaxpayer,
    accessLinkSpouse: SSR_DeliveredAPI_GetAccessLinkParameter.accessLinkSpouse,
  }
}


export const signatureStatusResponseBody: SignatureStatusResponseBody = {
  ...baseResponseBody,
  data: {
    signStatus: SSR_DeliveredAPI_SignatureStatusParameter.signStatus,
    documentStatus: SSR_DeliveredAPI_SignatureStatusParameter.documentStatus,
    signMode: SSR_DeliveredAPI_SignatureStatusParameter.signMode,
  }
}

export const signersInfoResponseBody: SignersInfoResponseBody = {
  ...baseResponseBody,
  data: {
    documentId: SSR_DeliveredAPI_SignerInfoParameter.documentId,
    signer: SSR_DeliveredAPI_SignerInfoParameter.signer,
    isSigned: SSR_DeliveredAPI_SignerInfoParameter.isSigned,
    signedOn: SSR_DeliveredAPI_SignerInfoParameter.signedOn,
    signerType: SSR_DeliveredAPI_SignerInfoParameter.signerType,
    order: SSR_DeliveredAPI_SignerInfoParameter.order,
    name: SSR_DeliveredAPI_SignerInfoParameter.name,
    signerGuid: SSR_DeliveredAPI_SignerInfoParameter.signerGuid,
    isDeceased: SSR_DeliveredAPI_SignerInfoParameter.isDeceased,
  }
}

export const deliveredReturnResponseBody: DeliveredReturnResponseBody = {
  ...baseResponseBody,
  data: {
    taxReturnId: SSR_DeliveredAPI_DeliveredReturnsParameter.taxReturnId,
    clientId: SSR_DeliveredAPI_DeliveredReturnsParameter.clientId,
    clientName: SSR_DeliveredAPI_DeliveredReturnsParameter.clientName,
    eroSignerFirstName: SSR_DeliveredAPI_DeliveredReturnsParameter.eroSignerFirstName,
    eroSignerLastName: SSR_DeliveredAPI_DeliveredReturnsParameter.eroSignerLastName,
    taxYear: SSR_DeliveredAPI_DeliveredReturnsParameter.taxYear,
    taxSoftware: SSR_DeliveredAPI_DeliveredReturnsParameter.taxSoftware,
    engagementType: SSR_DeliveredAPI_DeliveredReturnsParameter.engagementType,
    signatureStatus: SSR_DeliveredAPI_DeliveredReturnsParameter.signatureStatus,
    draftStatus: SSR_DeliveredAPI_DeliveredReturnsParameter.draftStatus,
    downloadStatus: SSR_DeliveredAPI_DeliveredReturnsParameter.downloadStatus,
    documentFilingType: SSR_DeliveredAPI_DeliveredReturnsParameter.documentFilingType,
    lastReminderDate: SSR_DeliveredAPI_DeliveredReturnsParameter.lastReminderDate,
    deliveredOn: SSR_DeliveredAPI_DeliveredReturnsParameter.deliveredOn,
    deletionDate: SSR_DeliveredAPI_DeliveredReturnsParameter.deletionDate,
    locationId: SSR_DeliveredAPI_DeliveredReturnsParameter.locationId,
    groupName: SSR_DeliveredAPI_DeliveredReturnsParameter.groupName,
  }
}

export const EFileFormsResponseBody: EFileFormResponseBody = {
  ...baseResponseBody,
  data: {
    clientId: SSR_DeliveredAPI_GetEFileFormsParameter.clientId,
    clientName: SSR_DeliveredAPI_GetEFileFormsParameter.clientName,
    engagementType: SSR_DeliveredAPI_GetEFileFormsParameter.engagementType,
    formNames: SSR_DeliveredAPI_GetEFileFormsParameter.formNames,
  }
}

export const deliveredReturnParameter: DeliveredReturnParameter = {
  clientIdQuery: SSR_DeliveredAPI_DeliveredReturnsParameter.clientIdQuery,
  clientNameQuery: SSR_DeliveredAPI_DeliveredReturnsParameter.clientNameQuery,
  taxYearQuery: SSR_DeliveredAPI_DeliveredReturnsParameter.taxYearQuery,
  eroQuery: SSR_DeliveredAPI_DeliveredReturnsParameter.eroQuery,
  signatureStatusQuery: SSR_DeliveredAPI_DeliveredReturnsParameter.signatureStatusQuery,
  draftStatusQuery: SSR_DeliveredAPI_DeliveredReturnsParameter.draftStatusQuery,
  engagementTypeQuery: SSR_DeliveredAPI_DeliveredReturnsParameter.engagementTypeQuery,
  deliveredAfterQuery: SSR_DeliveredAPI_DeliveredReturnsParameter.deliveredAfterQuery,
  pageSizeQuery: SSR_DeliveredAPI_DeliveredReturnsParameter.pageSizeQuery,
  pageNumberQuery: SSR_DeliveredAPI_DeliveredReturnsParameter.pageNumberQuery,
  sortByQuery: SSR_DeliveredAPI_DeliveredReturnsParameter.sortByQuery,
  sortOrderQuery: SSR_DeliveredAPI_DeliveredReturnsParameter.sortOrderQuery,
}

export const setDownloadStatusRequestBody: SetDownloadStatusRequestBody = {
  requiredTaxReturnId: SSR_ReturnStatus_SetDownloadStatusParameter.taxReturnId,
}

export const SSR_ArchivedReturn_getAccessLinkRequestParameter: RequiredTaxReturnIdParameter = {
  requiredTaxReturnId: SSR_ArchivedReturnAPI_GetAccessLinkParameter.taxReturnIdQuery
}

export const SSR_ArchivedReturn_getAccessLinkResponseBody: AccessLinkResponseBody & Data = {
  ...baseResponseBody,
  data: {
    clientId: SSR_ArchivedReturnAPI_GetAccessLinkParameter.clientId,
    clientName: SSR_ArchivedReturnAPI_GetAccessLinkParameter.clientName,
    taxYear: SSR_ArchivedReturnAPI_GetAccessLinkParameter.taxYear,
    signatureStatus: SSR_ArchivedReturnAPI_GetAccessLinkParameter.signatureStatus,
    accessLinkTaxpayer: SSR_ArchivedReturnAPI_GetAccessLinkParameter.accessLinkTaxpayer,
    accessLinkSpouse: SSR_ArchivedReturnAPI_GetAccessLinkParameter.accessLinkSpouse,
  }
}

export const SSR_ArchivedReturnAPI_ArchivedReturnsRequestParameter: SSR_ArchivedReturn_ArchivedReturnsRequestParameter = {
  clientIdQuery: SSR_ArchivedReturn_ArchivedReturnsParameter.clientIdQuery,
  clientNameQuery: SSR_ArchivedReturn_ArchivedReturnsParameter.clientNameQuery,
  taxYearQuery: SSR_ArchivedReturn_ArchivedReturnsParameter.taxYearQuery,
  eroQuery: SSR_ArchivedReturn_ArchivedReturnsParameter.eroQuery,
  signatureStatusQuery: SSR_ArchivedReturn_ArchivedReturnsParameter.signatureStatusQuery,
  engagementTypeQuery: SSR_ArchivedReturn_ArchivedReturnsParameter.engagementTypeQuery,
  deliveredAfterQuery: SSR_ArchivedReturn_ArchivedReturnsParameter.deliveredAfterQuery,
  pageSizeQuery: SSR_ArchivedReturn_ArchivedReturnsParameter.pageSizeQuery,
  pageNumberQuery: SSR_ArchivedReturn_ArchivedReturnsParameter.pageNumberQuery,
  sortByQuery: SSR_ArchivedReturn_ArchivedReturnsParameter.sortByQuery,
  sortOrderQuery: SSR_ArchivedReturn_ArchivedReturnsParameter.sortOrderQuery,
}

export const SSR_ArchivedReturnAPI_ArchivedReturnsResponseBody: SSR_ArchivedReturn_ArchivedReturnsResponseBody = {
  ...baseResponseBody,
  data:{
    taxReturnId: SSR_ArchivedReturn_ArchivedReturnsParameter.taxReturnId,
    clientId: SSR_ArchivedReturn_ArchivedReturnsParameter.clientId,
    clientName: SSR_ArchivedReturn_ArchivedReturnsParameter.clientName,
    eroSignerFirstName: SSR_ArchivedReturn_ArchivedReturnsParameter.eroSignerFirstName,
    eroSignerLastName: SSR_ArchivedReturn_ArchivedReturnsParameter.eroSignerLastName,
    taxYear: SSR_ArchivedReturn_ArchivedReturnsParameter.taxYear,
    taxSoftware: SSR_ArchivedReturn_ArchivedReturnsParameter.taxSoftware,
    engagementType: SSR_ArchivedReturn_ArchivedReturnsParameter.engagementType,
    signatureStatus: SSR_ArchivedReturn_ArchivedReturnsParameter.signatureStatus,
    downloadStatus: SSR_ArchivedReturn_ArchivedReturnsParameter.downloadStatus,
    documentFilingType: SSR_ArchivedReturn_ArchivedReturnsParameter.documentFilingType,
    lastReminderDate: SSR_ArchivedReturn_ArchivedReturnsParameter.lastReminderDate,
    deliveredOn: SSR_ArchivedReturn_ArchivedReturnsParameter.deliveredOn,
    deletionDate: SSR_ArchivedReturn_ArchivedReturnsParameter.deletionDate,
    locationId: SSR_ArchivedReturn_ArchivedReturnsParameter.locationId,
    groupName: SSR_ArchivedReturn_ArchivedReturnsParameter.groupName,
  }
}

export const SSR_ArchivedReturnAPI_DeleteReturn_AND_MoveToDeliveredRequestBody: SecondBaseRequestBody = {
  ...secondBaseRequestBody
}

export const SSR_ArchivedReturnAPI_SignatureStatusRequestParameter: SSR_ArchivedReturn_SignatureStatusRequestParameter = {
  taxReturnIdQuery: SSR_ArchivedReturnAPI_SignatureStatusParameter.taxReturnIdQuery
}

export const SSR_ArchivedReturnAPI_SignatureStatusResponseBody: SSR_ArchivedReturn_SignatureStatusResponseBody = {
  ...baseResponseBody,
  data: {
    signStatus: SSR_ArchivedReturnAPI_SignatureStatusParameter.signStatus,
    documentStatus: SSR_ArchivedReturnAPI_SignatureStatusParameter.documentStatus,
    signMode: SSR_ArchivedReturnAPI_SignatureStatusParameter.signMode,
  }
}

export const SSR_ArchivedReturnAPI_SignerInformationResponseBody = {
  ...baseRequestBody,
  data: {
    documentId: SSR_ArchivedReturnAPI_SignerInfoParameter.documentId,
    signer: SSR_ArchivedReturnAPI_SignerInfoParameter.signer,
    isSigned: SSR_ArchivedReturnAPI_SignerInfoParameter.isSigned,
    signedOn: SSR_ArchivedReturnAPI_SignerInfoParameter.signedOn,
    signerType: SSR_ArchivedReturnAPI_SignerInfoParameter.signerType,
    order: SSR_ArchivedReturnAPI_SignerInfoParameter.order,
    name: SSR_ArchivedReturnAPI_SignerInfoParameter.name,
    signerGuid: SSR_ArchivedReturnAPI_SignerInfoParameter.signerGuid,
    isDeceased: SSR_ArchivedReturnAPI_SignerInfoParameter.isDeceased,
  }
}